import { render } from "./additional-information-section.vue?vue&type=template&id=79eed5a4&scoped=true&ts=true"
import script from "./additional-information-section.vue?vue&type=script&lang=ts"
export * from "./additional-information-section.vue?vue&type=script&lang=ts"

import "./additional-information-section.vue?vue&type=style&index=0&id=79eed5a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79eed5a4"]])

export default __exports__